import React from 'react'
import ThemeContext from './TranslationContext'

// This function takes a component...
export function withContext(Component) {
	// ...and returns another component...
	function ThemedComponent(props) {
		// ... and renders the wrapped component with the context theme!
		// Notice that we pass through any additional props as well
		return (
			<ThemeContext.Consumer>
				{ context => <Component { ...props } context={ context } /> }
			</ThemeContext.Consumer>
		)
	}
	ThemedComponent.fetchQueries = Component.fetchQueries
	ThemedComponent.propTypes = Component.propTypes
	return ThemedComponent
}



// WEBPACK FOOTER //
// ./src/client/utils/withContext.js